<template>
    <div id="search-form" v-if="mixinIsAuthenticated()">

        <b-form class="form-content-mobile">
            <div class="form-toggler">
                <div class="input-with-icon-wrapper" @click="toggleMobileSearch">
                    <div class="input-icon">
                        <svg width="37" height="22" viewBox="0 0 37 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.488034 11.0151C0.503254 11.4144 0.653835 11.7967 0.915036 12.0991L9.32507 21.0352C9.63312 21.3216 10.0315 21.4912 10.4514 21.5151C10.8713 21.5391 11.2864 21.4156 11.625 21.166C11.9243 20.8571 12.0904 20.4429 12.0874 20.0127C12.0844 19.5825 11.9126 19.1707 11.609 18.866L5.69604 12.5911H34.654C35.0723 12.5911 35.4734 12.4249 35.7692 12.1291C36.0649 11.8334 36.2311 11.4324 36.2311 11.0142C36.2311 10.5959 36.0649 10.1947 35.7692 9.89892C35.4734 9.60318 35.0723 9.43701 34.654 9.43701H5.69604L11.609 3.16211C11.8915 2.84652 12.0491 2.43865 12.052 2.01513C12.0549 1.59162 11.903 1.18155 11.625 0.862059C11.288 0.608263 10.872 0.482175 10.4508 0.506346C10.0296 0.530517 9.63079 0.703458 9.32507 0.994139L0.915036 9.92993C0.775756 10.0734 0.666307 10.2431 0.593014 10.4292C0.519722 10.6153 0.484038 10.8142 0.488034 11.0142V11.0151Z" fill="#333333"/>
                        </svg>
                    </div>
                    <div class="input-with-icon">
                        <b-form-input
                            id="input-1"
                            type="email"
                            disabled
                            :placeholder="(geo.label == '' ? 'Inserisci una località' : geo.label)"
                        >
                        </b-form-input>
                    </div>
                </div>

                <!-- eccezione in home/home-in-vadobay: icona lente al posto dell'icona filtri ed apertura ricerca al posto dei filtri -->
                <div class="buttons">
                    <div class="toggle-search-wrapper">
                        <div id="toggle-search-settings" class="icon" @click="toggleMobileSearch">
                            <SvgChevronRight class="open-search-settings" />
                        </div>
                    </div>
                    <div class="toggle-filters-wrapper" v-if="!triggerMobileSearch" @click="toggleMobileFilters" >
                        <SvgFilters class="open-search-settings" />
                    </div>
                </div>
            </div>
            <!--<before-header v-if="showMobileSearch | showMobileFilter" />-->
            <Fields v-on:submit-clicked="submitClicked" v-if="showMobileSearch" />
            <Filters v-on:category-changed="categoryChanged" v-on:filter-changed="filterChanged" v-if="showMobileFilter" :resultsFiltered="resultsFiltered" />
        </b-form>

        <b-form class="form-content-desktop">
            <Fields :offset="offset" v-on:submit-clicked="submitClicked" :elementSlug="elementSlug"/>
            <!--<Filters v-on:filter-changed="filterChanged" />-->
        </b-form>

    </div>
</template>

<script>
import SvgFilters from '@/components/svg/filters'
import SvgChevronRight from '@/components/svg/chevron-right'

export default {
    name: 'search-form',
    components:
    {
        Fields: () => import('./fields').then(function(Fields) {
            window.console.log('async: PageHeader Component loaded')
            return Fields
        }),
        Filters: () => import('./filters').then(function(Filters) {
            window.console.log('async: Filters Component loaded')
            return Filters
        }),
        SvgFilters,
        SvgChevronRight,
    },
    props:{
        offset: Number,
        elementSlug: String,
        submitCallback: Function,
        resultsFiltered: Array,
        ignoreMapRedirect: {
          type: Boolean,
          default: false,
        }
    },
    computed:
    {
        geo: {
            get() { return this.$store.state.geo },
            set(value) { this.mixinSendMutation('setGeo',value) }
        }
    },

    data() {
        return {
            showMobileFilter: false,
            showMobileSearch: false,
            triggerMobileSearch: this.$route.name == 'homepage' | this.$route.name == 'in-vadobay' | this.$route.name == 'in-vivamod', // decide se aprire il menu di ricerca o il menu filtri
        }
    },

    methods:
    {
        submitClicked()
        {

            // al cerca azzero offset autoscroll
            // così se dal dettaglio viene fatta una nuova ricerca, non si viene autoscrollati in basso
            this.mixinSendMutation('setScroll', window.pageYOffset)

            this.submitCallback()
            this.$emit('submit-search')
            this.showMobileSearch = false
            document.body.classList.remove('mobile-search-on')
        },
        filterChanged()
        {
            this.$emit('filter-changed')
            this.showMobileFilter = false
            document.body.classList.remove('mobile-filter-on')
        },
        categoryChanged()
        {
            this.$emit('category-changed')
        },
        toggleClass(element, className) {
            if (element.classList.contains(className)) {
                element.classList.remove(className);
            } else {
                element.classList.add(className);
            }
        },
        toggleMobileFilters()
        {
            this.toggleClass(document.body,'mobile-filter-on')
            this.showMobileFilter = !this.showMobileFilter
            this.showMobileSearch = false
            document.body.classList.remove('mobile-search-on')
        },
        toggleMobileSearch()
        {
            this.toggleClass(document.body,'mobile-search-on')
            this.showMobileSearch = !this.showMobileSearch
            this.showMobileFilter = false
            document.body.classList.remove('mobile-filter-on')
        }
    },
    mounted(){
      if(this.ignoreMapRedirect){
        let geo = this.geo
        geo.ignoreMapRedirect = true
        this.geo = geo
      }

    }
}
</script>

<style lang="scss">
    @import './src/scss/_search-form.scss';

    #hero #search-form
    {
        // deve mantenere il colore fisso in vadobay e il gradiente in vivamod
        // senza l'if verrebbe usato il gradiente sass in vadobay ed il gradiente --var in vivamod
        @if($customize)
        {
            @include customize-gradient;
        }
    }

    //#hero 
    #search-form
    {
        position:relative;
        .form-toggler
        {
            display:block;
        }
        .buttons
        {
            position:absolute;
            top:20px;
            right:0;
            z-index: 10;
            display: flex;
            align-items: center;
            justify-content: center;
            height:50px;
            font-size: 1rem;
        }
        .toggle-search-wrapper,
        .toggle-filters-wrapper
        {
            width:34px;
            height:34px;
            display: flex;
            align-items: center;
            justify-content: center;
            svg
            {
                width:20px;
                height:auto;
            }            
        }
        .toggle-search-wrapper
        {
            transform:rotate(90deg);
            transform-origin: center center;
            transition:$transition-base;
        }
        .toggle-filters-wrapper
        {
        }
        #toggle-search-settings
        {
            padding:0;
            margin-left:0 !important;
        }
        .form-toggler
        {
            padding-right:80px;
        }
    }

    body.mobile-search-on
    {
        overflow: hidden;
        #hero
        {
            overflow: visible;
        }
        #hero:after
        {
            opacity:0;
        }
        //#hero 
        #search-form .toggle-search-wrapper
        {
            transform:rotate(-90deg);
        }
        .input-with-icon-wrapper
        {
            display:none !important;
        }
        .search-form-fields
        {
            margin-top:0 !important;
        }
        #typeahead-container
        {
            padding-right:80px;
        }
        .page-in-vivamod,
        .page-homepage
        {
            #typeahead-container
            {
                padding-right:50px;
            }
        }

        #search-form
        {
            overflow: hidden;
            padding-bottom:1rem;
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;
        }
        .search-form-fields
        {
            padding-right:8px; //box shadow tagliata
        }
    }

    .page-in-vivamod,
    .page-homepage
    {
        #search-form
        {
            .toggle-filters-wrapper
            {
                display:none;
            }
            .toggle-search-wrapper
            {
                right:14px;
                top:22px;
            }
            .form-toggler
            {
                padding-right:50px;
            }
            .buttons
            {
                width:80px;
            }
        }
    }
</style>